import React from 'react';
import PropTypes from 'prop-types';
import styles from "./ImageLinkCard.module.css";
import { Smartphone } from "lucide-react";

const ServiceCard = ({ title, description, icon: Icon, url, className }) => {
  const classes = [styles.ServiceCard, className].join(" ");
  const hasUrl = url && url !== "#";
  const cardContent = (
    <>
      <div className={styles.iconContainer}>
        {Icon ? <Icon size={36} /> : <Smartphone size={36} />}
      </div>
      <h3 className={styles.title}>{title}</h3>
      <p className={styles.description}>{description}</p>
    </>
  );
  return (
    <div className={classes} data-testid="ServiceCard">
      {hasUrl ? (
        <a href={url} target="_blank" rel="noreferrer" className={styles.link}>
          {cardContent}
        </a>
      ) : (
        <div className={styles.link}>{cardContent}</div>
      )}
    </div>
  );
};

ServiceCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  icon: PropTypes.elementType,
  url: PropTypes.string,
  className: PropTypes.string,
};

ServiceCard.defaultProps = {
  description: "",
  url: null,
  className: "",
};

export default ServiceCard;
